import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[1000] overflow-y-auto bg-background"
}
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { class: "text-sm font-normal uppercase tracking-wide" }
const _hoisted_4 = { class: "relative mx-auto max-w-[var(--site-max-width)] px-4" }
const _hoisted_5 = { class: "mx-auto max-w-2xl pb-8 pt-16 text-center tablet-up:pt-20" }
const _hoisted_6 = { class: "m-0 mb-8 text-xl !font-light tracking-wide text-foreground tablet-up:text-2xl" }
const _hoisted_7 = { class: "pb-16" }
const _hoisted_8 = {
  key: 0,
  class: "text-center text-xs text-muted-foreground"
}
const _hoisted_9 = {
  key: 1,
  class: "text-center text-xs text-warning"
}

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { X } from 'lucide-vue-next';

import { freeze, unfreeze } from '@motillo/ui-scroll-freeze';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useSearch from '@/composables/useSearch';
import useEventListener from '@/composables/useEventListener';

import SearchBar from '@/components/search/SearchBar.vue';
import SearchResult from '@/components/search/SearchResult.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Search',
  setup(__props) {

const { route } = useContext();
const { websiteText } = useWebsiteTexts();
const { searchQuery, error, searchResult, clearSearch } = useSearch();
const { useEmitterEventListener } = useEventListener();

const isOpen = ref(false);

const zeroHitsCaption = computed(() => {
  if (searchQuery.value && searchResult.value?.products?.length === 0) {
    return websiteText('search__no_hits_caption').value?.replace('{0}', searchQuery.value);
  }
  return '';
});

function open() {
  freeze('Search');
  isOpen.value = true;
}

function close() {
  unfreeze('Search');
  isOpen.value = false;
  clearSearch();
}

function onKeydown(e: KeyboardEvent) {
  if (e.key === 'Escape' && isOpen.value) {
    close();
  }
}

onMounted(() => {
  window.addEventListener('keydown', onKeydown);
  watch(
    () => route.pathname,
    () => close(),
  );
});

onUnmounted(() => {
  window.removeEventListener('keydown', onKeydown);
});

useEmitterEventListener('Search:Open', open);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "search-fade" }, {
    default: _withCtx(() => [
      (isOpen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("button", {
              type: "button",
              class: "btn-bare fixed right-4 top-4 z-[1001] flex items-center gap-1.5 p-2 text-muted-foreground transition-colors hover:text-foreground tablet-up:right-6 tablet-up:top-6",
              "aria-label": _unref(websiteText)('getmygift__search__close').value || 'Stäng',
              onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(websiteText)('getmygift__search__close').value || 'Stäng'), 1),
              _createVNode(_unref(X), { class: "h-7 w-7" })
            ], 8, _hoisted_2),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(websiteText)('getmygift__search__pagetitle').value), 1),
                _createVNode(SearchBar)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SearchResult),
                (zeroHitsCaption.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(zeroHitsCaption.value), 1))
                  : _createCommentVNode("", true),
                (_unref(error))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(websiteText)('getmygift__search__unknownerror').value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})